(function () {
    'use strict';

    angular
        .module('payees')
        .config(PayeesRoute);

    /* @ngInject */
    function PayeesRoute($stateProvider) {
        $stateProvider
            .state ('root.payees', {
                url: '/payees',
                abstract: true
            })
            .state ('root.payees.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/payees/templates/payees-list.html',
                        controller: 'PayeesController',
                        controllerAs: 'payees'
                    }
                },
                params: {
                    filters: null,
                },
                resolve: {
                    payees,
                }
            });
    }
    
    function payees($stateParams, PayeesService) { 
        return PayeesService.listPayees($stateParams.filters);
    }
})();